import { EntityRepository, Repository } from "typeorm";
import { Grn } from "./raw-material-grn.entity";

@EntityRepository(Grn)
export class GrnRepository extends Repository<Grn> {

}